import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllCandidates, getTopCandidate } from './data';

const styles = {
  page: { maxWidth: 860, margin: '0 auto', padding: '0 1.5rem 3rem', fontFamily: 'Georgia, serif' },
  topbar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1rem 0', borderBottom: '0.5px solid rgba(0,0,0,0.12)', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '0.75rem' },
  logo: { fontSize: 22, fontWeight: 700, color: '#1a1a1a', letterSpacing: '-0.3px', fontFamily: 'Georgia, serif' },
  logoSub: { fontSize: 11, color: '#888', letterSpacing: '0.06em', textTransform: 'uppercase', fontFamily: 'monospace', marginTop: 2 },
  nav: { display: 'flex', gap: '1.25rem', flexWrap: 'wrap' },
  navLink: { fontSize: 13, color: '#666', textDecoration: 'none', cursor: 'pointer', background: 'none', border: 'none', fontFamily: 'Georgia, serif' },
  dateBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.25rem', flexWrap: 'wrap', gap: '0.5rem' },
  dateLabel: { fontSize: 12, color: '#999', fontFamily: 'monospace', letterSpacing: '0.04em' },
  liveDot: { display: 'flex', alignItems: 'center', gap: 5, fontSize: 11, color: '#A32D2D', fontFamily: 'monospace' },
  dot: { width: 7, height: 7, borderRadius: '50%', background: '#E24B4A' },
  sectionLabel: { fontSize: 11, color: '#999', textTransform: 'uppercase', letterSpacing: '0.07em', fontFamily: 'monospace', marginBottom: '0.75rem' },
  featuredCard: { border: '0.5px solid rgba(0,0,0,0.1)', borderRadius: 12, background: '#fff', padding: '1.5rem', marginBottom: '1.25rem' },
  featuredHeader: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '1.25rem', gap: '1rem', flexWrap: 'wrap' },
  avatar: { width: 52, height: 52, borderRadius: '50%', background: '#FCEBEB', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, fontWeight: 700, color: '#A32D2D', flexShrink: 0, border: '0.5px solid #F09595', fontFamily: 'Georgia, serif' },
  candidateName: { fontSize: 20, fontWeight: 700, color: '#1a1a1a', marginBottom: 3, fontFamily: 'Georgia, serif' },
  candidateDesc: { fontSize: 13, color: '#666', lineHeight: 1.5 },
  scoreBig: { fontSize: 48, fontWeight: 700, color: '#A32D2D', lineHeight: 1, fontFamily: 'Georgia, serif' },
  scoreDenom: { fontSize: 13, color: '#999', fontFamily: 'monospace', marginTop: 2, textAlign: 'right' },
  meterTrack: { background: '#F1EFE8', borderRadius: 4, height: 10, width: '100%', overflow: 'hidden', marginBottom: '0.75rem' },
  meterFill: { height: '100%', borderRadius: 4, background: '#E24B4A' },
  catBars: { display: 'flex', flexDirection: 'column', gap: 7, marginBottom: '1rem' },
  catRow: { display: 'flex', alignItems: 'center', gap: 8 },
  catName: { fontSize: 12, color: '#666', width: 210, flexShrink: 0 },
  catTrack: { flex: 1, background: '#F1EFE8', borderRadius: 3, height: 5, overflow: 'hidden' },
  catFill: { height: '100%', borderRadius: 3 },
  catScore: { fontSize: 11, color: '#999', fontFamily: 'monospace', width: 36, textAlign: 'right', flexShrink: 0 },
  cardFooter: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderTop: '0.5px solid rgba(0,0,0,0.08)', paddingTop: '1rem', flexWrap: 'wrap', gap: '0.5rem' },
  trend: { fontSize: 13, color: '#A32D2D' },
  detailBtn: { fontSize: 13, color: '#666', background: 'none', border: '0.5px solid rgba(0,0,0,0.2)', borderRadius: 8, padding: '5px 14px', cursor: 'pointer', fontFamily: 'Georgia, serif' },
  scriptureBlock: { borderLeft: '2px solid #F09595', padding: '0.75rem 1rem', marginBottom: '1.5rem', background: '#FCEBEB', borderRadius: '0 8px 8px 0' },
  scriptureText: { fontSize: 14, color: '#791F1F', fontFamily: 'Georgia, serif', lineHeight: 1.6, fontStyle: 'italic' },
  scriptureRef: { fontSize: 11, color: '#A32D2D', fontFamily: 'monospace', marginTop: 4 },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '0.9rem', marginBottom: '1.5rem' },
  miniCard: { border: '0.5px solid rgba(0,0,0,0.1)', borderRadius: 12, background: '#fff', padding: '1rem', cursor: 'pointer' },
  miniAvatar: { width: 32, height: 32, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, flexShrink: 0, fontFamily: 'Georgia, serif' },
  miniName: { fontSize: 13, fontWeight: 700, color: '#1a1a1a', fontFamily: 'Georgia, serif' },
  miniSub: { fontSize: 11, color: '#888' },
  miniTrack: { background: '#F1EFE8', borderRadius: 3, height: 4, overflow: 'hidden', marginBottom: 6 },
  miniFill: { height: '100%', borderRadius: 3 },
  miniLabel: { fontSize: 11, color: '#999', fontFamily: 'monospace' },
  eventsCard: { border: '0.5px solid rgba(0,0,0,0.1)', borderRadius: 12, background: '#fff', padding: '1.25rem', marginBottom: '1.5rem' },
  eventRow: { display: 'flex', gap: 10, alignItems: 'flex-start', paddingBottom: '0.65rem', borderBottom: '0.5px solid rgba(0,0,0,0.06)', marginBottom: '0.65rem' },
  eventDate: { fontSize: 11, color: '#999', fontFamily: 'monospace', minWidth: 68, paddingTop: 2 },
  eventText: { fontSize: 13, color: '#1a1a1a', lineHeight: 1.5, flex: 1 },
  badgeRed: { fontSize: 10, padding: '2px 7px', borderRadius: 99, background: '#FCEBEB', color: '#A32D2D', flexShrink: 0, marginTop: 2 },
  badgeAmber: { fontSize: 10, padding: '2px 7px', borderRadius: 99, background: '#FAEEDA', color: '#854F0B', flexShrink: 0, marginTop: 2 },
  badgeGray: { fontSize: 10, padding: '2px 7px', borderRadius: 99, background: '#F1EFE8', color: '#5F5E5A', flexShrink: 0, marginTop: 2 },
  disclaimer: { fontSize: 11, color: '#999', lineHeight: 1.65, borderTop: '0.5px solid rgba(0,0,0,0.08)', paddingTop: '1rem', fontStyle: 'italic' },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0,1fr))', gap: '0.6rem', marginBottom: '1.25rem' },
  statCard: { background: '#f9f9f7', borderRadius: 8, padding: '0.65rem 0.8rem' },
  statLabel: { fontSize: 10, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 3 },
  statVal: { fontSize: 18, fontWeight: 700, color: '#1a1a1a', fontFamily: 'Georgia, serif' },
  statSub: { fontSize: 10, color: '#aaa', marginTop: 1 },
};

const today = new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });

export default function Homepage() {
  const navigate = useNavigate();
  const featured = getTopCandidate();
  const allCandidates = getAllCandidates();
  const otherCandidates = allCandidates.filter(c => c.id !== featured.id);
  const allEvents = allCandidates.flatMap(c => (c.recentEvents || []).map(e => ({ ...e, candidateName: c.name, candidateId: c.id }))).sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, 6);

  return (
    <div style={{ background: '#fafaf8', minHeight: '100vh' }}>
      <div style={styles.page}>

        <div style={styles.topbar}>
          <div>
            <div style={styles.logo}>The Antichrist-o-meter</div>
            <div style={styles.logoSub}>Daily prophetic behavioural analysis · est. 2026</div>
          </div>
          <nav style={styles.nav}>
            <button style={styles.navLink} onClick={() => window.scrollTo(0,0)}>Rankings</button>
            <button style={styles.navLink} onClick={() => navigate('/methodology')}>Methodology</button>
            <button style={styles.navLink} onClick={() => navigate('/methodology')}>Scripture index</button>
          </nav>
        </div>

        <div style={styles.dateBar}>
          <span style={styles.dateLabel}>Assessment date: {today}</span>
          <span style={styles.liveDot}><span style={styles.dot}></span> Updated daily at 00:01 UTC</span>
        </div>

        <div style={styles.sectionLabel}>Featured candidate · highest current score</div>

        <div style={styles.featuredCard}>
          <div style={styles.featuredHeader}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
              <div style={styles.avatar}>{featured.short}</div>
              <div>
                <div style={styles.candidateName}>{featured.name}</div>
                <div style={styles.candidateDesc}>{featured.description}</div>
              </div>
            </div>
            <div style={{ textAlign: 'right', flexShrink: 0 }}>
              <div style={styles.scoreBig}>{featured.score}%</div>
              <div style={styles.scoreDenom}>of 666 possible</div>
            </div>
          </div>

          <div style={styles.meterTrack}>
            <div style={{ ...styles.meterFill, width: `${featured.score}%` }}></div>
          </div>

          <div style={styles.catBars}>
            {featured.categories.map((cat, i) => (
              <div key={i} style={styles.catRow}>
                <span style={styles.catName}>{cat.name}</span>
                <div style={styles.catTrack}>
                  <div style={{ ...styles.catFill, width: `${cat.pct}%`, background: cat.pct > 80 ? '#E24B4A' : '#BA7517' }}></div>
                </div>
                <span style={styles.catScore}>{cat.score}</span>
              </div>
            ))}
          </div>

          <div style={styles.statsGrid}>
            <div style={styles.statCard}><div style={styles.statLabel}>Days tracked</div><div style={styles.statVal}>{featured.daysTracked}</div><div style={styles.statSub}>since Jan 2026</div></div>
            <div style={styles.statCard}><div style={styles.statLabel}>Peak score</div><div style={styles.statVal}>{featured.peakScore}%</div><div style={styles.statSub}>{featured.peakDate}</div></div>
            <div style={styles.statCard}><div style={styles.statLabel}>Scored events</div><div style={styles.statVal}>{featured.scoredEvents}</div><div style={styles.statSub}>across 7 categories</div></div>
            <div style={styles.statCard}><div style={styles.statLabel}>Weekly change</div><div style={{ ...styles.statVal, color: featured.weeklyDelta > 0 ? '#A32D2D' : '#5F5E5A' }}>+{featured.weeklyDelta}</div><div style={styles.statSub}>pts this week</div></div>
          </div>

          <div style={styles.cardFooter}>
            <span style={styles.trend}>↑ +{featured.weeklyDelta} pts this week</span>
            <button style={styles.detailBtn} onClick={() => navigate(`/candidate/${featured.id}`)}>Full profile →</button>
          </div>
        </div>

        <div style={styles.scriptureBlock}>
          <div style={styles.scriptureText}>"He shall exalt himself and magnify himself above every god, and shall speak astonishing things against the God of gods."</div>
          <div style={styles.scriptureRef}>Daniel 11:36 · Category I trigger · featured candidate</div>
        </div>

        <div style={styles.sectionLabel}>All candidates · current cycle</div>

        <div style={styles.grid}>
          {otherCandidates.sort((a,b) => b.score - a.score).map(c => (
            <div key={c.id} style={styles.miniCard} onClick={() => navigate(`/candidate/${c.id}`)}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.65rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div style={{ ...styles.miniAvatar, background: c.color + '22', color: c.color, border: `0.5px solid ${c.color}66` }}>{c.short}</div>
                  <div>
                    <div style={styles.miniName}>{c.name.split(' ')[0]} {c.name.split(' ')[1] || ''}</div>
                    <div style={styles.miniSub}>{c.description.split('·')[0].trim()}</div>
                  </div>
                </div>
                <div style={{ fontSize: 19, fontWeight: 700, color: c.color, fontFamily: 'Georgia, serif' }}>{c.score}%</div>
              </div>
              <div style={styles.miniTrack}><div style={{ ...styles.miniFill, width: `${c.score}%`, background: c.color }}></div></div>
              <div style={styles.miniLabel}>{c.status}</div>
            </div>
          ))}
        </div>

        <div style={styles.sectionLabel}>Latest scored events</div>

        <div style={styles.eventsCard}>
          {allEvents.map((ev, i) => (
            <div key={i} style={{ ...styles.eventRow, ...(i === allEvents.length - 1 ? { borderBottom: 'none', marginBottom: 0, paddingBottom: 0 } : {}) }}>
              <span style={styles.eventDate}>{ev.date}</span>
              <span style={styles.eventText}><strong>{ev.candidateName.split(' ')[0]}:</strong> {ev.text}</span>
              <span style={ev.type === 'danger' ? styles.badgeRed : ev.type === 'warning' ? styles.badgeAmber : styles.badgeGray}>{ev.category} {ev.delta}</span>
            </div>
          ))}
        </div>

        <div style={styles.disclaimer}>
          The Antichrist-o-meter is a satirical publication. All scores are based on documented public behaviour assessed against prophetic criteria from the Book of Revelation, the Book of Daniel, and the Pauline Epistles, with full citations available in each candidate profile. This site does not assert theological claims, predict actual end times, or constitute defamation of any individual. Probably.
        </div>

      </div>
    </div>
  );
}
